<template>
  <v-container class="pa-0 ma-0">
    <v-row>
      <v-col
        xs="12"
        md="4"
      >
        <profile-picture-upload
          @select="onSelectPicture"
          @upload="onUploadPicture"
        />
      </v-col>
      <v-col
        xs="12"
        md="8"
      >
        <v-card
          :disabled="isLoading"
        >
          <v-card-text>
            <v-text-field
              v-model="model.displayName"
              label="Display Name"
              type="text"
            />
            <v-text-field
              v-model="model.email"
              label="Email"
              type="email"
            />
            <!--            <international-phone-number-->
            <!--              :init="initialModel.phoneNumber"-->
            <!--              @change="onPhoneNumberChange"-->
            <!--            />-->

            <v-divider class="my-3" />
            <v-row>
              <v-col
                xs="12"
                md="8"
              >
                <div>Password</div>
                <div v-if="isEmailVerified">
                  Click the button on the right if you need to reset your password.
                </div>
                <div v-if="!isEmailVerified">
                  Verify your email in order to reset your password
                </div>
              </v-col>
              <v-col
                xs="12"
                md="4"
                class="text-right"
              >
                <v-btn
                  v-if="isEmailVerified && !sentPasswordResetEmail"
                  rounded
                  outlined
                  color="primary"
                  @click="doSendPassword"
                >
                  Send reset email
                </v-btn>
                <span v-if="sentPasswordResetEmail">
                  We have sent a password reset link to {{ getAuthUser.email }}
                </span>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-divider class="mb-5" />

        <v-btn
          :width="isLoading ? '250px' : ''"
          rounded
          outlined
          color="primary"
          :loading="isLoading"
          :disabled="!hasChanged"
          @click="save"
        >
          <template v-slot:loader>
            <span>
              <v-progress-circular
                :size="20"
                :width="2"
                indeterminate
                color="primary"
              />
              {{ loadingText }}
            </span>
          </template>
          Save
        </v-btn>
      </v-col>
    </v-row>

    <relogin-dialog
      @action="onRelogin"
    />
  </v-container>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import { isEqual, get } from 'lodash'
import ReloginDialog from '@/components/ReloginDialog'
import ProfilePictureUpload from '@/components/Profile/ProfilePictureUpload'
import { uploadFile } from "../../services/storage.service"

export default {
  components: {
    ReloginDialog,
    ProfilePictureUpload
  },
  data() {
    return {
      isLoading: false,
      sentPasswordResetEmail: false,
      loadingText: '',
      progress: 0,
      password: '',
      confirmPassword: '',
      selectedPicture: null,
      model: {
        displayName: '',
        email: '',
        phoneNumber: '',
      },
      initialModel: {}
    }
  },
  computed: {
    ...mapGetters([ 'getAuthUser', 'isEmailVerified' ]),
    hasChanged() {
      console.log('haschanged', !isEqual(this.model, this.initialModel))
      return !isEqual(this.model, this.initialModel)
    },
  },
  mounted() {
    this.init()
  },
  methods: {
    ...mapActions([ 'updateAuthProfile', 'updateAuthEmail', 'setReloginDialog', 'sendPasswordResetEmail' ]),
    onRelogin() {
      this.save()
    },
    onSelectPicture(file) {
      if (file) {
        this.selectedPicture = file
        const url  = URL.createObjectURL(file)
        this.model.photoURL = url
      } else {
        this.model.photoURL = null
      }

    },
    onUploadPicture(photoURL) {
      console.log('caught url', photoURL)
      this.model.photoURL = photoURL
    },
    init(value) {
      const { displayName, email, phoneNumber, photoURL } = this.getAuthUser
      const model = { displayName, email, phoneNumber, photoURL }

      if (value) {
        this.model[ value ] = this.getAuthUser[ value ]
        this.initialModel[ value ] = this.getAuthUser[ value ]
      } else {
        this.model = { ...model }
        this.initialModel = { ...model }
      }
    },
    getIfDiff(field) {
      return get(this.model, field) !== get(this.initialModel, field)
        ? get(this.model, field)
        : undefined
    },

    async doImageUpload() {
      this.$refs.profilePictureUpload.doUpload()
    },

    async doEmailUpdate() {
      const email = this.getIfDiff('email')
      let result = true
      if (email) {
        const emailPayload = { email }

        console.log('updating email')
        await this.updateAuthEmail(emailPayload)
          .then(() => {
            console.log('reset email initted')
            this.init('email')
          })
          .catch(e => {
            result = false
            const { code } = e
            if (code === 'auth/requires-recent-login') {
              this.setReloginDialog(true)
            } else {
              console.log(e)
            }
          })
      }

      return result
    },

    async doProfileUpdate() {
      const displayName = this.getIfDiff('displayName')
      const photoURL = this.getIfDiff('photoURL')
      console.log('dpoing profile uplads')

      let result = true

      if (displayName !== undefined || photoURL !== undefined) {
        const profilePayload = { displayName, photoURL }
        console.log(profilePayload)
        // Reinit after update, so if the user saves again we ignore this call
        await this.updateAuthProfile(profilePayload)
          .then(() => {
            if (displayName !== undefined) this.init('displayName')
            if (photoURL !== undefined) this.init('photoURL')
          })
          .catch(e => {
            console.log(e)
            result = false
          })
      }

      return result
    },

    async doSendPassword() {
      this.sentPasswordResetEmail = true
      await this.sendPasswordResetEmail()
    },

    async save() {
      this.isLoading = true
      let shouldContinue = true

      const photoURL = this.getIfDiff('photoURL')

      const otherUploadStuff = async () => {
        this.loadingText = 'Updating profile...'
        shouldContinue = await this.doProfileUpdate()

        if (shouldContinue) {
          this.loadingText = 'Updating email...'
          shouldContinue = await this.doEmailUpdate()
        }
      }

      if (photoURL) {
        this.loadingText = 'Uploading photo... '
        const path = [ 'test/profile.', this.getFileExtension() ].join('')
        this.progress = 0

        const onSnapshot = (snapshot) => {
          this.progress  = (snapshot.bytesTransferred / snapshot.totalBytes) * 100
          this.loadingText = `Uploading photo... ${this.progress}%`
          console.log(this.progress)
        }

        const onError = (err) => {
          console.log(err)
        }

        const onComplete = async (uploadTask) => {
          this.model.photoURL = await uploadTask.snapshot.ref.getDownloadURL()

          await otherUploadStuff()
        }

        uploadFile(this.selectedPicture, path, onSnapshot, onError, onComplete)
      } else {
        await otherUploadStuff()
      }

      this.loadingText = ''
      this.isLoading = false
    },

    getFileExtension() {
      return this.selectedPicture
        ? this.selectedPicture.name.split('.').pop()
        : ''
    },
    onPhoneNumberChange(phoneObject) {
      const { number } = phoneObject || {}

      if (number) {
        this.model.phoneNumber = number
      }
    }
  }
}
</script>
